import { render, staticRenderFns } from "./NetdocPPort.vue?vue&type=template&id=5f84c3d4&scoped=true"
import script from "./NetdocPPort.vue?vue&type=script&lang=js"
export * from "./NetdocPPort.vue?vue&type=script&lang=js"
import style0 from "./NetdocPPort.vue?vue&type=style&index=0&id=5f84c3d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f84c3d4",
  null
  
)

export default component.exports